module.exports = __webpack_public_path__ + "img/info_light.a9014337.svg";